import { ChatMessageBase } from "../../molecules/ChatMessageBase/ChatMessageBase";
import React from "react";
import { MessageWithActionAndData } from "@me8eon/sessions_messages";
import { findWidgetByKey } from "../../../AiWidgets/widgetRepository";

type Props = {
    message: MessageWithActionAndData;
    isLast: boolean;
    isStreaming?: boolean;
}

const toolMetaComponentRepository = {
    widget: findWidgetByKey,
};

const Component = (content: string): string | React.ReactNode | null => {
    try {
        const values = JSON.parse(content);
        const allowedEntry = Object.keys(values?._meta).find(key => Object.keys(toolMetaComponentRepository).includes(key));
        if (allowedEntry) {
            const findComponentFn = toolMetaComponentRepository[allowedEntry as keyof typeof toolMetaComponentRepository];
            const Component = findComponentFn(values);

            if (Component) {
                return <Component values={values} />;
            }
        }
    } catch {
        return null;
    }
    return null;
};

export const ToolMessageComponent: React.FC<Props> = ({ message, isLast }) => {
    const contentToDisplay = Component(message.content as string);
    if (!contentToDisplay) return null;
    return <ChatMessageBase content={contentToDisplay} variant={"assistant"} isLast={isLast} />;
};